import React, { useEffect,useState } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Calendar, User, Eye, ArrowRight, Zap, Shield, HardHat, Wrench, Search, Clock } from 'lucide-react';
import imagen1 from '../assets/images/BlogPage/blogpageimg1.webp';
import imagen2 from '../assets/images/BlogPage/blogpageimg2.webp';
import imagenwidget1 from '../assets/images/BlogPage/imagenwidget1.webp';
import imagenwidget2 from '../assets/images/BlogPage/imagenwidget2.webp';
import imagenwidget3 from '../assets/images/BlogPage/imagenwidget3.webp';
import imagenwidget4 from '../assets/images/BlogPage/imagenwidget4.webp';
import imagenwidget5 from '../assets/images/BlogPage/imagenwidget5.webp';
import imagenwidget6 from '../assets/images/BlogPage/imagenwidget6.webp';

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.

const handleSearch = () => {
};

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  const images = [imagen1, imagen2];

  const particles = Array.from({ length: 25 });
  const [currentIndex, setCurrentIndex] = useState(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  const blogPosts = [
    {
      id: 1,
      title: "Normativas Referentes en Seguridad Eléctrica 2026",
      excerpt: "Conoce las últimas actualizaciones en normativas de seguridad para trabajos con tensión y su impacto en el sector.",
      content: "Las normativas de seguridad eléctrica han evolucionado significativamente en 2026, introduciendo nuevos estándares para equipos de protección personal...",
      category: "normativas",
      author: "Ing. Carlos Mendoza",
      date: "2025-12-23",
      readTime: "6 min",
      views: 135,
      image: imagenwidget1,
      featured: true
    },
    {
      id: 2,
      title: "Mantenimiento Preventivo de Guantes Dieléctricos",
      excerpt: "Guía completa sobre el cuidado y mantenimiento de guantes dieléctricos para garantizar máxima protección.",
      content: "El mantenimiento adecuado de los guantes dieléctricos es fundamental para garantizar la seguridad del trabajador...",
      category: "mantenimiento",
      author: "Ing. María González",
      date: "2024-01-18",
      readTime: "7 min",
      views: 189,
      image: imagenwidget2
    },
    {
      id: 3,
      title: "Trabajos en Líneas de Alta Tensión: Procedimientos Seguros",
      excerpt: "Protocolos esenciales para realizar trabajos seguros en líneas de transmisión de alta tensión.",
      content: "Los trabajos en líneas de alta tensión requieren procedimientos específicos y equipos especializados...",
      category: "alta-tension",
      author: "Ing. Roberto Silva",
      date: "2024-01-15",
      readTime: "10 min",
      views: 312,
      image: imagenwidget3
    },
    {
      id: 4,
      title: "EPPs Innovadores para el Sector Eléctrico",
      excerpt: "Descubre las últimas innovaciones en equipos de protección personal para trabajadores eléctricos.",
      content: "La tecnología en EPPs ha avanzado considerablemente, ofreciendo mejor protección y comodidad...",
      category: "epps",
      author: "Ing. Ana Rodríguez",
      date: "2024-01-12",
      readTime: "6 min",
      views: 156,
      image: imagenwidget4
    },
    {
      id: 5,
      title: "Certificaciones Internacionales: IEC vs ASTM",
      excerpt: "Comparativa detallada entre las principales certificaciones internacionales para equipos eléctricos.",
      content: "Las certificaciones IEC y ASTM son fundamentales en la industria eléctrica, cada una con sus particularidades...",
      category: "certificaciones",
      author: "Ing. Carlos Mendoza",
      date: "2024-01-10",
      readTime: "8 min",
      views: 278,
      image: imagenwidget5
    },
    {
      id: 6,
      title: "Capacitación en Seguridad Eléctrica: Mejores Prácticas",
      excerpt: "Metodologías efectivas para la capacitación del personal en seguridad eléctrica industrial.",
      content: "Una capacitación efectiva es la base de la seguridad en el trabajo eléctrico...",
      category: "capacitacion",
      author: "Ing. María González",
      date: "2024-01-08",
      readTime: "9 min",
      views: 203,
      image: imagenwidget6
    }
  ];

  const categories = [
    { key: 'all', label: 'Todas', icon: BookOpen, count: blogPosts.length },
    { key: 'normativas', label: 'Normativas', icon: Shield, count: 1 },
    { key: 'mantenimiento', label: 'Mantenimiento', icon: Wrench, count: 1 },
    { key: 'alta-tension', label: 'Alta Tensión', icon: Zap, count: 1 },
    { key: 'epps', label: 'EPPs', icon: HardHat, count: 1 },
    { key: 'certificaciones', label: 'Certificaciones', icon: Shield, count: 1 },
    { key: 'capacitacion', label: 'Capacitación', icon: User, count: 1 }
  ];

  const filteredPosts = blogPosts.filter(post => {
    const matchesCategory = selectedCategory === 'all' || post.category === selectedCategory;
    const matchesSearch = searchTerm === '' || 
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  const featuredPost = blogPosts.find(post => post.featured);

  return (
    <div className="relative min-h-screen py-12 overflow-hidden">
      {/* SLIFER FADE */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute inset-0">
          {images.map((img, index) => {
            const isActive = index === currentIndex;

            return (
              <motion.div
                key={index}
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${img})` }}
                initial={{ opacity: 0, scale: 1.02, filter: "blur(8px)" }}
                animate={
                  isActive
                    ? {
                      opacity: 1,
                      scale: 1,
                      filter: "blur(0px)"
                    }
                    : {
                      opacity: 0,
                      scale: 1.05,
                      filter: "blur(6px)"
                    }
                }
                transition={{
                  duration: 2.5,
                  ease: [0.4, 0, 0.2, 1]
                }}
              />
            );
          })}
        </div>

        {/* OVERLAY GRADIENTE (SUAVIZADO ARRIBA → ABAJO) */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-black/70 to-black z-10" />
        
      </div>

      <div className="container mx-auto px-4">    
        {/* Barra de búsqueda */}
        <motion.div
          className="max-w-2xl mx-auto mb-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <div className="relative">
            <button
              onClick={handleSearch}
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-blue-600 transition-colors"
            >
              <Search className="w-5 h-5" />
            </button>

            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
              placeholder="Buscar artículos..."
              className="w-full pl-12 pr-12 py-3 border-2 border-white rounded-xl shadow-xl shadow-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            />
          </div>
        </motion.div>

        {/* Categorías */}
        <motion.div
          className="flex flex-wrap justify-center gap-3 mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {categories.map((category, index) => (
            <motion.button
              key={category.key}
              onClick={() => setSelectedCategory(category.key)}
              className={`flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-all ${
                selectedCategory === category.key
                  ? 'bg-gradient-to-r from-blue-500 to-blue-800 text-white shadow-2xl shadow-gray-700'
                  : 'bg-gradient-to-r from-gray-50 to-gray-400 text-gray-700 shadow-xl shadow-gray-700 hover:from-yellow-500 hover:to-yellow-800'
              }`}
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.95 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0 + index * 0.05 }}
            >
              <category.icon className="w-4 h-4" />
              {category.label}
              <span className={`text-xs px-2 py-0.5 rounded-full ${
                selectedCategory === category.key ? 'bg-white/20' : 'bg-white/60'
              }`}>
                {category.count}
              </span>
            </motion.button>
          ))}
        </motion.div>

        {/* Artículo Destacado */}
        {featuredPost && selectedCategory === 'all' && (
          <motion.div
            className="mb-12"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
          >
            <h2 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-800 to-blue-500 bg-clip-text text-transparent">
              ⭐ Artículo Destacado
            </h2>
            <div className="bg-gradient-to-r from-yellow-50 to-white border-2 border-yellow-800 rounded-2xl overflow-hidden shadow-xl shadow-gray-700 hover:shadow-2xl transition-all group">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <div className="relative overflow-hidden">
                  <img
                    src={featuredPost.image}
                    alt={featuredPost.title}
                    className="w-full h-80 lg:h-full object-cover brightness-110 contrast-105 saturate-110 group-hover:scale-105 transition-all duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white/40 via-white/40 to-white/40 transition-opacity duration-500" />
                  <div className="absolute top-4 left-4 bg-gradient-to-r from-yellow-500 to-yellow-800 shadow-lg shadow-gray-700 text-white px-3 py-1 rounded-full text-sm font-bold">
                    Destacado
                  </div>
                </div>
                <div className="p-8 flex flex-col justify-center">
                  <h3 className="text-3xl font-bold text-gray-800 mb-4 group-hover:text-blue-800 transition-colors">
                    {featuredPost.title}
                  </h3>
                  <p className="text-gray-600 text-lg mb-6 leading-relaxed">
                    {featuredPost.excerpt}
                  </p>
                  <div className="flex items-center gap-6 text-sm text-gray-500 mb-6">
                    <div className="flex items-center gap-2">
                      <User className="w-4 h-4" />
                      {featuredPost.author}
                    </div>
                    <div className="flex items-center gap-2">
                      <Calendar className="w-4 h-4" />
                      {new Date(featuredPost.date).toLocaleDateString('es-CO')}
                    </div>
                    <div className="flex items-center gap-2">
                      <Eye className="w-4 h-4" />
                      {featuredPost.views} vistas
                    </div>
                  </div>
                  <motion.button
                    className="bg-gradient-to-r from-blue-500 to-blue-800 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 hover:from-blue-700 hover:to-blue-800 transition-all w-fit"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Leer más <ArrowRight className="w-4 h-4" />
                  </motion.button>
                </div>
              </div>
            </div>
          </motion.div>
        )}

        {/* Grid de Artículos */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {filteredPosts.filter(post => !post.featured || selectedCategory !== 'all').map((post, index) => (
            <motion.article
              key={post.id}
              className="bg-white rounded-xl shadow-xl shadow-gray-700 hover:shadow-2xl transition-all group border border-white overflow-hidden"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0 + index * 0.1 }}
              whileHover={{ y: -5 }}
            >
              <div className="relative overflow-hidden rounded-t-xl">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover brightness-10 contrast-100 saturate-100 group-hover:scale-110 transition-all duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-white/40 via-white/40 to-white/40 transition-opacity duration-500" />
                <div className="absolute bottom-4 left-4 right-4 text-white">
                  <span className="bg-gradient-to-r from-blue-500 to-blue-800 px-3 py-1 rounded-full text-xs font-semibold">
                    {categories.find(cat => cat.key === post.category)?.label}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-800 transition-colors line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3 leading-relaxed">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1">
                      <User className="w-2.5 h-2.5" />
                      <span>{post.author.split(' ')[1]}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="w-2.5 h-2.5" />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-1">
                    <Eye className="w-2.5 h-2.5" />
                    <span>{post.views}</span>
                  </div>
                </div>

                <motion.button
                  className="w-full bg-gradient-to-r from-gray-50 to-gray-400 text-gray-700 py-2 px-4 rounded-lg font-medium hover:from-yellow-500 hover:to-yellow-800 hover:text-white transition-all flex items-center justify-center gap-2"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Leer artículo <ArrowRight className="w-4 h-4" />
                </motion.button>
              </div>
            </motion.article>
          ))}
        </div>

        {filteredPosts.length === 0 && (
          <motion.div
            className="text-center py-20"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <BookOpen className="w-20 h-20 text-white mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-white mb-2">No se encontraron artículos</h3>
            <p className="text-white">
              {searchTerm ? `No hay artículos que coincidan con "${searchTerm}"` : 'No hay artículos en esta categoría'}
            </p>
          </motion.div>
        )}

      </div>
    </div>
  );
};

export default BlogPage;

//-- Proyecto diseñado, programado, testeado, ejecutado y publicado por Alex Castillo.
//-- Autor: Alex Castillo © 2026 Alex Castillo – Todos los derechos reservados.